import ReactComponentMounter from '../utils/react-component-mounter';
import MentionableComment from '../components/MentionableComment';

ReactComponentMounter.register({
  MentionableComment
});
